export default __webpack_public_path__ + "static/spiritual-india-journey-1-77b449d70112714323a76427b079e05b.jpg";